module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Dedication"
    }
  }, [_c('p', {
    staticClass: "fm-title1"
  }, [_vm._v("Dedication"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page6"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_vm._v("To Vivienne, as ever, for unfailing support.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_vm._v("‘Necessity can turn any weapon to advantage.’"), _c('br'), _vm._v("Publilius Syrus (fl46–29 BC), "), _c('i', [_vm._v("Moral Sayings")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-para2"
  }, [_vm._v("‘Beware the fury of the patient man.’"), _c('br'), _vm._v("John Dryden, ‘Absalom and Achitophel’ (1681)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c76fd43","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Dedication.vue
// module id = 72
// module chunks = 0